import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SegmentedControlField } from '../SegmentedControlField';

const WEEKDAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
] as const;

type SendDayPropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const SendDay = <T extends FieldValues>({
  fieldName,
}: SendDayPropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <SegmentedControlField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.SEND_DAY')}
      options={WEEKDAYS.map((weekday) => ({
        value: weekday,
        label: t(`REPORTS.ENUMS.WEEKDAY_SHORT.${weekday}`),
      }))}
    />
  );
};
